if (window['jQuery']) {
    window.jQuery(function () {
        if (window['TCTServer'] && window['TCTServer']['admin']) return;
        if (!window['TCT'] || !window['TCT']['hasTracking']) return;
        if (!window['TCT'] || !window['TCT']['Testing']) return;
        if (!window['branch'] || !window['branch']['banner']) return;

        var testData = false;
        var isFood = !!window.dataLayer && !!window.dataLayer[0] && window.dataLayer[0]['genre'] === 'food';
        var TRACKING_PREFIX = 'download_app_banner_';

        if (shouldShowBanner()) {
            if (shouldRunTest()) {
                TCT.Testing.getTestData(940, null).then(function (data) {
                    TCT.debug('Test data:', data);

                    testData = data;

                    scheduleBanner();

                }, scheduleBanner);
            } else {
                scheduleBanner();
            }
        }

        function isAndroid() {
            var body = document.querySelector("body");
            var ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("android") > -1;  //&& ua.indexOf("mobile");
        }

        function isIOS() {
            var body = document.querySelector("body");
            var ua = navigator.userAgent;
            return /iPad|iPhone|iPod/.test(ua) && !window['MSStream']
        }

        function isArticle() {
            return window['TCTServer'] && !!window['TCTServer']['article'];
        }

        function shouldShowBanner() {
            return isArticle() && (isAndroid() || isIOS());
        }

        function shouldRunTest() {
            return false;
        }


        function scheduleBanner() {
            var duid = TCT.TrackingUtils.getSnowplowDuid();
            if (!!duid) {
                showBanner();
            } else {
                setTimeout(scheduleBanner, 25);
            }
        }

        function showBanner() {
            var url = window.location.href;
            var customCSS = '#branch-banner .content .left .details .title { font-size: ' + (screen.width > 380 ? '26px' : '22px') + '; }' +
                '#branch-banner .content .left .details .description { font-size: 12px; }' +
                '#branch-banner .content .left .details .description { max-height: 70px;} ';

            customCSS += "#branch-banner .vertically-align-middle{top:0;}" +
                "#branch-banner .content {background:white}" +
                "#branch-banner .vertically-align-middle {transform: translateY(0);}" +
                "#branch-banner .content { transition:height 0.375s ease-out;}" +
                "#branch-banner .content .left {display: flex;justify-content: center;position: relative;height: auto;}" +
                "#branch-banner .content #branch-banner-close{background-color: white;font-size: 32px;padding: 0 22px 0 12px;top:8px;line-height: 1.2em;width:auto}" +
                "#branch-banner .content .left .details .description{font-size:13px}" +
                "@media(max-width:370px) {#branch-banner .content .left .details .description{font-size:12px}}" +
                "#branch-banner .content .left .icon {display: none;}" +
                "#branch-banner .content .left .details {flex: 1 0 auto;max-width: 410px;}" +
                "#branch-banner .content .left .details .title{overflow:hidden;transition:all 0.375s ease-out;}" +
                "#branch-banner .content .left .details .description {flex: 0 1 180px;padding-right: 10px;max-width: 200px;align-self: center;line-height: 18px;}" +
                "#branch-banner .content .left .details #tct-banner-description {display: flex;flex: 1 0 auto;width: 100%;overflow:hidden;transition:all 0.375s ease-out;}" +
                "@media(max-width:415px) {#branch-banner .content .left .details #tct-banner-description {justify-content:space-between}}" +
                "#branch-banner .content .left .details #tct-banner-description .right{flex: 0 3 195px;}" +
                "#branch-banner .content .left .details .title {display: block;padding-right: 6px;}" +
                "#branch-banner .content .left .details .reviews {display: block;overflow:hidden;transition:all 0.375s ease-out;}" +
                "#branch-banner .content .left .details .reviews .star span {color:#ffbe2f;}" +
                "#branch-banner .content .left .details .reviews {font-size:15px; line-height:22px}" +
                "#branch-banner .content .left .details #tct-banner-first-column {flex: 1 0 auto;padding-right: 37px;}" +
                "#branch-banner .content .right {margin: 0;padding: 0;height: auto;}" +
                "@media(max-width:415px) {#branch-banner .content .right {max-width:100px!important}}" +
                "#branch-banner .content .right #branch-sms-form-container #branch-mobile-action {margin: 0;padding: 0;background-color: #6071ff;border-bottom-color: #6071ff;font-size: 16px;}" +
                ".branch-banner-is-active .share-icons.fixed {top:117px}" +
                ".branch-banner-is-active .share-icons.fixed.smaller  {top:1117px}"+
                "#branch-banner .content .reviews .stars .star span.full>svg {fill: #ffbe2f;}"+
                "#branch-banner .content .reviews .stars .star span.half>svg {fill: #ffbe2f;}";

            var title = 'Culture Trip App';
            if (isAndroid()){
                title="Culture Trip for Android"
            }else if(isIOS()){
                title="Culture Trip for iOS"
            }
            var buttonText = "Install";
            if (isIOS()){
                buttonText="GET";
            }
            var whenInstalledText = "Open";
            var description = 'Find exciting things to see & do wherever you are!';
            var icon = 'https://cdn.theculturetrip.com/logo/ct-logo-75x75.png';

            if (isFood) {
                description = 'Install and eat at the best local restaurants anywhere you are';
            }

            window['branch'].addListener('didShowBanner', onDidShowBanner);

            TCT.debug('SP DUID:', TCT.TrackingUtils.getSnowplowDuid());

            window['branch']['banner']({
                icon: icon,
                title: title,
                description: description,
                openAppButtonText: whenInstalledText,
                downloadAppButtonText: buttonText,
                showiPad: true,
                showiOS: true,
                showAndroid: true,
                showDesktop: false,
                iframe: false,
                mobileSticky: true,
                position: 'top',
                rating: 4.7,
                customCSS: customCSS,
                forgetHide: 1
            }, {
                feature: testData && testData.variant ? testData.variant : '',
                channel: 'web',
                data: {
                    'interrupt branch param': download_popup_deep_link,
                    'domain user id': TCT.TrackingUtils.getSnowplowDuid(),
                    '$desktop_url': url,
                    '$ios_url': 'https://itunes.apple.com/us/app/id1146832951',
                    '$ipad_url': 'https://itunes.apple.com/us/app/id1146832951',
                    '$og_title': 'Check out this article from \'Culture Trip\'',
                    '$og_description': "'" + download_popup_post_title + "'",
                    '$android_url': 'market://details?id=culturetrip.com'
                }

            });

            function reportBannerView(testData) {
                trackCTANoInteraction(TRACKING_PREFIX + 'view');

                if (testData && testData.variant) {
                    TCT.Testing.reportVariantVisible(testData);
                }
            }

            function onDidShowBanner() {
                TCT.debug('Branch onWillShowBanner');
                debugger;

                var topBar = document.getElementById("nav-home");
                var banner = document.getElementById("branch-banner");

                if (banner) {
                    // check button text to see if we need to make it disappear (in case app is already installed)
                    var button = document.getElementById('branch-mobile-action');
                    if (button && button.innerHTML == whenInstalledText) {
                        // hide banner
                        document.body.style.marginTop = 0;
                        banner.style.display = 'none';

                        if (window['branch']['closeBanner']) {
                            window['branch']['closeBanner']();
                        }

                        trackCTANoInteraction(TRACKING_PREFIX + 'auto_hide');
                        return;
                    }


                    reportBannerView(testData);


                    banner.parentNode.removeChild(banner);

                    var content = banner.childNodes[0];
                    var right = content.childNodes[0];
                    var left = content.childNodes[1],
                        closeIcon = left.childNodes[0],
                        description = left.childNodes[2];

                    content.removeChild(right);

                    right.style.paddingTop = 0 + "px";
                    right.style.width = "100%";

                    right.childNodes[0].style.width = "100%";
                    right.childNodes[0].style.textAlign = "center";
                    right.childNodes[0].style.marginTop = "-10px";
                    right.childNodes[0].childNodes[0].style.width = "65%";
                    right.childNodes[0].childNodes[0].style.lineHeight = "35px";
                    right.childNodes[0].childNodes[0].style.height = "35px";
                    right.childNodes[0].childNodes[0].style.fontSize = "22px";
                    jQuery(topBar.parentNode).prepend(banner);
                    left.style.paddingTop = screen.height > screen.width ? "12%" : "6%";
                    banner.style.position = "fixed";
                    banner.style.zIndex = 100;

                    var height = Math.max(screen.height / 3, 200) + 'px';

                    (function ($) {

                        var $banner = $(banner),
                            $details = $('.left .details', $banner),
                            $right = $(right),
                            $left = $(left),
                            title = $('.title', $details),
                            reviews = $('.reviews', $details),
                            description = $('.description', $details),
                            bannerContent = $("#branch-banner .content"),
                            scrollStart = false;

                        description.remove();

                        //Add description section and button section to be under one div
                        $details.append($('<div id="tct-banner-description"></div>').append(description).append($right));

                        var $buttonLink = $('#branch-mobile-action', $details);
                        $right.css('max-width', "195px");
                        closeIcon.remove();
                        // left.removeChild(closeIcon);
                        content.prepend(closeIcon);

                        $buttonLink.css("width", "100%");
                        height = "120px";
                        $(content).css("height", height);
                        // content.style.height = height;
                        // left.style.paddingTop = "16px";
                        $left.css("padding-top", "16px");

                        //Clone this for smaller banner
                        var cloneDetails = $right.clone().prop('id', 'button-banner-sticky').css({
                                "max-height": "0",
                                "overflow": 'hidden',
                                "transition": "all 0.375s ease-out"
                            }),
                            cloneTitle = $(".title", $details).clone().prop('id', 'title-banner-sticky'),
                            cloneReview = $(".reviews", $details).clone().prop('id', 'review-banner-sticky');

                        //Hide the it until we start scroll
                        $details.append($('<div id="tct-banner-first-column"></div>').append(cloneTitle).append(cloneReview).css({
                            "max-height": "0",
                            "overflow": 'hidden',
                            "transition": "all 0.375s ease-out"
                        }));
                        $details.append(cloneDetails);
                        $('#branch-sms-form-container', cloneDetails).css("margin", '0');
                        //Save true if the smaller banner is display instead the big one
                        scrollStart = false;

                        function scrollDownloadAppBanner(){
                            //hide the bigger banner and show the samller one
                            if (this.scrollY > 0 && !scrollStart) {
                                var height = "73px";
                                scrollStart = true;
                                $('>.title', $details).css({"max-height": "0px", "max-width": "0"});
                                $('>.reviews', $details).css({"max-height": "0px", "max-width": "0"});
                                $('#tct-banner-description', $details).css({
                                    "max-height": "0px",
                                    "max-width": "0"
                                });
                                $('#tct-banner-first-column', $details).css({
                                    "max-height": "60px",
                                    "max-width": "200px"
                                });
                                cloneDetails.css({"max-height": "60px", "max-width": "200px"});
                                $details.css("display", "flex");
                                bannerContent.css("height", height);
                                $('body').css("margin-top", height);
                            }
                            //hide the smaller banner and show the bigger one
                            else if (this.scrollY == 0 && scrollStart) {
                                scrollStart = false;
                                height = "120px";
                                $('>.title', $details).css({
                                    "max-height": "70px",
                                    "max-width": "300px"
                                });
                                $('>.reviews', $details).css({
                                    "max-height": "70px",
                                    "max-width": "300px"
                                });
                                $('#tct-banner-description', $details).css({
                                    "max-height": "70px",
                                    "max-width": "600px"
                                });
                                $('#tct-banner-first-column', $details).css({
                                    "max-height": "0px",
                                    "max-width": "0"
                                });
                                cloneDetails.css({"max-height": "0px", "max-width": "0"});
                                $details.css("display", "block");
                                bannerContent.css("height", height);
                                $('body').css("margin-top", height);

                            }
                        }
                        //Add event that check every time if need to display the smaller banner If we in top 0 we display the bigger banner
                        $(window).on('scroll',scrollDownloadAppBanner);
                        $('#branch-banner-close').one("click",function(){
                            //This remove the bind event that change the banner from small to big.
                            $(window).off('scroll',scrollDownloadAppBanner);
                        });
                        //default value for all test except controller variant
                        var desc = $('.description', $banner),
                            buttonContainer = $('#branch-sms-form-container', $banner),
                            button = $('.button', $banner);

                        title = $('.title', $banner);
                        title.css('font-size', '16px');
                        title.css('font-weight', '400');
                        title.css('font-family', "ProximaNova-SemiBold");
                        desc.css('font-family', "ProximaNova-Regular");
                        desc.css('font-weight', 'normal');
                        button.css('font-size', '16px');
                        button.css('font-weight', '400');
                        button.css('font-family', "ProximaNova-Regular");
                        button.css('letter-spacing', "normal");
                        buttonContainer.css("padding", "0");
                        buttonContainer.css("margin", "0");
                        button.addClass('ios-branch-button');
                        $right.css('max-width', 'none');


                    })(window.jQuery);

                    var margin = height;

                    document.body.style.marginTop = height;
                    right.style.marginBottom = "0px";

                    if (isIOS()) {
                        (function ($) {
                            var $banner = $(banner),
                                right = $('.right', $banner),
                                title = $('.title', $banner),
                                desc = $('.description', $banner),
                                button = $('.button', $banner);

                            button.addClass('ios-branch-button');
                            right.css('max-width', 'none');
                        })(window.jQuery);
                    }

                    document.getElementById("branch-banner-close").addEventListener("click", function () {
                        trackCTA(TRACKING_PREFIX + "close");
                    });

                    document.getElementById("branch-mobile-action").addEventListener("click", function () {
                        trackClick();
                    });
                }
            }
        }

        function trackClick() {
            trackConversion(TRACKING_PREFIX + 'clicked');
            trackCTA(TRACKING_PREFIX + 'clicked');
        }

    });

}